import { getData } from '../../../shared/api/core';
import { DataService } from '../../../shared/auth/DataService';
import { backend_url } from '../../../shared/auth/setting';

export const getHealthMonitorLogs = (params) =>
  getData(`/health-monitor/logs?${new URLSearchParams(params).toString()}`);

export const getHealthMonitorSummary = () => getData(`/health-monitor/summary`);

export const postHealthMonitorCleanup = async () => {
  const url = `${backend_url}/health-monitor/cleanup`;
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: await DataService.getFetchHeader('/health-monitor/cleanup', {}),
  });
  if (!response.ok) throw new Error('Cleanup failed');
  return response.text();
};
